import { SET_WEIGHT_TOLERANCES } from '../types/weightTolerance'
import {
  addWeightToleranceAPI,
  updateWeightToleranceAPI,
  deleteWeightToleranceAPI,
  getWeightTolerancesAPI,
} from '../api/weightTolerance'
import { addMessageCurry } from '../utils/api'

export const setTolerances = (payload) => ({
  type: SET_WEIGHT_TOLERANCES,
  payload: payload,
})

export const getTolerances = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWeightTolerancesAPI(), dispatch).then((tolerances) => {
        resolve(tolerances)
        dispatch(setTolerances({ tolerances }))
      })
    })
  }
}

export const updateTolerance = (tolerance) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateWeightToleranceAPI(tolerance), dispatch).then((tolerance) => {
        resolve(tolerance)
      })
    })
  }
}

export const addWeightTolerance = (tolerance) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(addWeightToleranceAPI(tolerance), dispatch).then((tolerance) => {
        resolve(tolerance)
      })
    })
  }
}

export const deleteWeightTolerance = (toleranceId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(deleteWeightToleranceAPI(toleranceId), dispatch).then((tolerance) => {
        resolve(tolerance)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/weightTolerance.js